var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-config-navBar"},[_c('div',{staticClass:"opple-config-navBar_item",class:{active: _vm.currentTab === 0},on:{"click":() => _vm.onItemClick(0)}},[_vm._v(" "+_vm._s(_vm.$t('ifttt.associatedConditioning'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }